import React from "react";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import styled from "styled-components";
import { AnalyticsEventTypes } from "../../../functional/analyticsUtils";
import { TelemetryImpression } from "../../TelemetryImpression";
import { withPalette } from "./PaletteProvider";
const StylableBlade = ({ fragmentId, className, children, palette, ...props }) => {
    return (React.createElement(TelemetryImpression, { impressionEvent: AnalyticsEventTypes.blade_impression },
        React.createElement("section", { ...props, id: fragmentId, className: [className, `blade-palette-${palette}`].join(" ") }, children)));
};
StylableBlade.defaultProps = {
    "data-testid": "blade",
    palette: "palette1",
};
export const Blade = withPalette(styled(StylableBlade) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`);
//# sourceMappingURL=Blade.js.map